import { Component, Input } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { ShopService } from '@app/services/shops/shop.service';
import {
  CheckoutExtensionCommonConfig,
  GiftUnlockExtension,
} from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';
import { DynamicRule, RuleEntity } from '@pdqdev/pdq-shared/dist/entities/Rules';
import { GiftUnlockMode } from '../../gift-unlock.component';
import PlacementMode = CheckoutExtensionCommonConfig.PlacementMode;

@Component({
  selector: 'gift-unlock-settings',
  templateUrl: './gift-unlock-settings.component.html',
  styleUrls: ['./gift-unlock-settings.component.scss'],
  standalone: false,
})
export class GiftUnlockSettingsComponent {
  @Input() formGroup: UntypedFormGroup;
  @Input() displayRules: DynamicRule[];
  @Input() displayRulesEntities: RuleEntity[];
  @Input() shopCurrencySymbol: string;
  @Input() offerTypeOptions: { label: string; value: string }[];

  PlacementMode = PlacementMode;
  OfferType = GiftUnlockExtension.OfferType;
  Mode = GiftUnlockMode;

  constructor(public shopService: ShopService) {}

  get maxxFeatureEnabled(): boolean {
    return this.shopService.isMaxxPredictEnabled;
  }

  get isMaxxAi(): boolean {
    return this.maxxFeatureEnabled && this.formGroup?.get('settings.mode')?.value === GiftUnlockMode.MAXX_AI;
  }

  get hasCartValueDisplayRule(): boolean {
    const rules = this.formGroup?.get('displayRules') as UntypedFormArray | null;
    return !!rules?.controls.some((c) => c.get('entity')?.value === RuleEntity.CART_VALUE);
  }

  get isCouponOfferType(): boolean {
    return this.formGroup?.get('settings.offerType')?.value === GiftUnlockExtension.OfferType.COUPON;
  }

  get shouldShowKeepInCart(): boolean {
    return this.hasCartValueDisplayRule && this.isCouponOfferType;
  }

  onModeChange(mode: GiftUnlockMode): void {
    if (!this.maxxFeatureEnabled) return;
    this.formGroup?.get('settings.mode')?.setValue(mode);
    this.formGroup?.get('settings.mode')?.markAsDirty();
  }
}
